import { unByKey } from 'ol/Observable';
import { Country, State, District, Municipality, SoloMunicipality } from './components';
import { navigationLayers } from '../layers/admin';
import { bus } from '../../main';
import { setNavLayerStyles } from '../layers/admin'
import { capitalize } from './baseClasses';

export class MapNavigator
{
    constructor(map)
    {
        this.map = map;
        this.mapEventKeys = [];
        const options = { highlightSource: navigationLayers.highlightedLayer.getSource() };
        this.soloMunicipality = new SoloMunicipality(options);
        this.municipality = new Municipality({ innerComponent: this.soloMunicipality, ...options });
        this.district = new District({ innerComponent: this.municipality, ...options });
        this.state = new State({ innerComponent: this.district,...options });
        this.country = new Country({ innerComponent: this.state,...options });
    }

    getLayerFilter()
    {
        return layer => [this.state.layer, this.district.layer, this.municipality.layer].includes(layer);
    }

    turnOnInteraction()
    {
        this._addOnClickNavigation();
        this._addHoverInteraction();
    }

    _addHoverInteraction()
    {
        const hoveredSource = navigationLayers.hoveredFeatureLayer.getSource();
        const getInfo = (ftr, component, division) => ({
            division,
            code: ftr.get(component.codeField),
            label: capitalize(ftr.get(component.labelField)),
            labelNepali: ftr.get(component.nepaliLabelField),
        });

        let timeout;
        const handleHover = event =>
        {
            clearTimeout(timeout);
            timeout = setTimeout(() =>
            {
                let info = {};
                hoveredSource.clear();
                let hoverFeature = {};
                this.map.forEachFeatureAtPixel( event.pixel, (feature, layer) =>
                {
                    if (layer===this.state.layer)
                    {
                        hoverFeature.state = feature;
                        info.state = getInfo(feature, this.state, 'state');
                    }
                    else if (layer===this.district.layer)
                    {
                        hoverFeature.district = feature;
                        info.district = getInfo(feature, this.district, 'district');
                    }
                    else if (layer===this.municipality.layer)
                    {
                        hoverFeature.municipality = feature;
                        info.municipality = getInfo(feature, this.municipality, 'municipality')
                    }
                }, { layerFilter: this.getLayerFilter() });
                this.hoveredInfo = info.municipality || info.district || info.state;
                if (Object.keys(hoverFeature).length)
                {
                    hoveredSource.addFeature( hoverFeature.municipality || hoverFeature.district || hoverFeature.state );
                }
                // emitting change-hovered-info so that the mapsection change the hover info label/description
                bus.$emit('change-hovered-info', this.hoveredInfo);
            }, 100);

        };
        const hoverEventKey = this.map.on('pointermove', handleHover);
        this.mapEventKeys.push(hoverEventKey);
    }

    _addOnClickNavigation()
    {
        const clickEventKey = this.map.on('singleclick', event =>
        {
            this.map.forEachFeatureAtPixel( event.pixel, (feature, layer) =>
            {
                // disable state selection when all districts or all munis in nepal is visible
                // if this is not done, we will select same feature multiple times
                const stateSelectDisabled = ["00","000"].includes(this.country.currentCode);
                
                if (layer===this.state.layer && !stateSelectDisabled) this.state.select( feature.get(this.state.codeField) );
                else if (layer===this.district.layer) this.district.select( feature.get(this.district.codeField) );
                else if (layer===this.municipality.layer) this.municipality.select( feature.get(this.municipality.codeField) );
            }, { layerFilter : this.getLayerFilter() } );
        });
        this.mapEventKeys.push(clickEventKey);
    }

    setLabelLanguage(language)
    {
        const stateLabelField = this.state.getLabelField(language);
        const districtLabelField = this.district.getLabelField(language);
        const muniLabelField = this.municipality.getLabelField(language);
        setNavLayerStyles(stateLabelField, districtLabelField, muniLabelField);
    }

    destroy()
    {
        const layers = [this.state.layer, this.district.layer, this.municipality.layer, this.soloMunicipality.layer];
        layers.forEach( layer => this.map.removeLayer(layer) );
        unByKey(this.mapEventKeys);
    }
}

let navigator = null;

export const getNavigator = () => navigator;

export const initNavigator = map =>
{
    navigator = new MapNavigator(map);
    navigator.turnOnInteraction();
    navigator.setLabelLanguage('english');
    return navigator;
};
